export const YellowMarkIcon = () => {
  return (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.779297 5.36364L4.35451 9L12.22 1" stroke="#FFB23F" strokeWidth="2" />
    </svg>
  );
};
